import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

function SessionModal({ isOpened, handleActive }) {
  return (
    <Transition appear show={isOpened} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[100000000000000000000000]"
        onClose={handleActive}
        style = {{zIndex: '100000000000000000000000000000000000000000000000'}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="w-full max-w-md transform overflow-hidden rounded-2xl dark:text-white bg-white dark:bg-[#343B46] p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title className="text-lg font-bold mb-6">
                  Session Almost Expired
                </Dialog.Title>

                <p>
                  Your session will expire if you do not take an action now!
                </p>

                <div className="flex justify-end">
                  <button
                    className="bg-blue-500 px-6 py-2.5 mt-6 rounded-full text-white font-bold"
                    onClick={handleActive}
                  >
                    Stay Logged In
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default SessionModal;
